export default "__VITE_ASSET__DmuRgUr5__"